import { useEffect, useState } from 'react';

const SHOW_AFTER = 400;
const HIDE_BEFORE_BOTTOM = 120;

function computeContactStackVisible() {
  if (window.scrollY <= SHOW_AFTER) return false;

  const contact = document.getElementById('contact');
  if (contact && contact.getBoundingClientRect().top <= window.innerHeight - HIDE_BEFORE_BOTTOM) {
    return false;
  }

  const footer = document.querySelector('.footer');
  if (footer && footer.getBoundingClientRect().top <= window.innerHeight - HIDE_BEFORE_BOTTOM) {
    return false;
  }

  return true;
}

export default function useHomeFloatingUi({ hideNearContactFooter = false } = {}) {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const update = () => {
      setVisible(
        hideNearContactFooter ? computeContactStackVisible() : window.scrollY > SHOW_AFTER,
      );
    };

    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update, { passive: true });
    update();

    return () => {
      window.removeEventListener('scroll', update);
      window.removeEventListener('resize', update);
    };
  }, [hideNearContactFooter]);

  return visible;
}
